export default __webpack_public_path__ + "static/swim-48f5807e87860586b770311efdc608f2.png";